import React from 'react';
import { getMailInboxUrl } from './otpMail.js';

function MailIcon() {
  return (
    <svg
      className="ui-otp-open-mail__icon"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}

/**
 * Opens the user's mail inbox (Gmail/Outlook/Yahoo web or native mail app via mailto).
 * Uses a real link so mobile Safari/Chrome hand off to the mail app reliably.
 */
export default function OtpOpenMailButton({ email, label = 'Open mail app', className = '' }) {
  const trimmed = String(email || '').trim();
  if (!trimmed) return null;

  const url = getMailInboxUrl(trimmed);
  const isWebMail = url.startsWith('http');

  return (
    <a
      href={url}
      className={`ui-otp-open-mail${className ? ` ${className}` : ''}`}
      target={isWebMail ? '_blank' : undefined}
      rel={isWebMail ? 'noopener noreferrer' : undefined}
    >
      <MailIcon />
      <span>{label}</span>
    </a>
  );
}
